/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Supplier_Style_CodeInputs */

const en_attribute_supplier_style_code = /** @type {(inputs: Attribute_Supplier_Style_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supplier style code`)
};

/**
* | output |
* | --- |
* | "Supplier style code" |
*
* @param {Attribute_Supplier_Style_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_supplier_style_code = /** @type {((inputs?: Attribute_Supplier_Style_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Supplier_Style_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_supplier_style_code(inputs)
});